<template>
	<b-container v-if="!isLoggedIn" fluid class="page">
		<b-row>
			<b-col lg="4" md="5" class="mh-login-left">
				<div class="mh-login-logo">
					<img src="../assets/images/logo.png" alt="Mopane Health">
				</div>
				<div class="mh-login-content mb-5">
					<h1>Forgot Password</h1>
					<p>Complete the following information and we will send you an email with a code to change your password</p>
					<b-form-input type="email" placeholder="Email Address" v-model="emailAddress" autocomplete="off" @keyup.enter="onSubmit()" class="mb-2" />
					<b-form-input v-if="!isProduction" type="text" placeholder="Company Code" v-model="companyCode" autocomplete="off" @keyup.enter="onSubmit()" class="mb-2" />
					<button class="btn btn-default" @click="forgotPassword">Send</button>
					<button class="btn btn-default btn-grey mt-2" @click="showPage('LoginPage')">Back</button>
				</div>
				<div class="mh-register-copyright"><p>&copy; MOPANE HEALTH 2021. All Rights Reserved.</p></div>
			</b-col>
			<b-col lg="8" md="7" class="text-center">
				<div class="mh-login-img">
					<div>
						<img src="../assets/images/login-graphic.png" alt="Login" class="img-fluid">
					</div>
				</div>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	export default {
		name: 'ForgotPasswordPage',
		data: function () {
			return {
				emailAddress: null,
				companyCode: null
			}
		},
		mounted() {
			if (this.isProduction) {
				this.companyCode = "mopane"
			}
		},
		computed: {
			environments: function () {
				return this.$store.state.MopaneApi.environments
			},
			isDevelopment: function () {
				return process.env.NODE_ENV === this.environments.development
			},
			isProduction: function () {
				return process.env.NODE_ENV === this.environments.production
			},
			isLoggedIn: function () {
				return this.$store.state.Profile != undefined && this.$store.state.Profile.isLoggedIn
			},
			emailAddressValid: function () {
				if (this.emailAddress == null || this.emailAddress == "") {
					this.$store.commit("Toasts/showError", { title: "Email", content: "Email is required" })

					return false
				}

				return true
			},
			companyCodeValid: function () {
				if (!this.isDevelopment)
					return true

				if (this.companyCode == null || this.companyCode == "") {
					this.$store.commit("Toasts/showError", { title: "Company Code", content: "Company Code is required" })

					return false
				}

				return true
			}
		},
		methods: {
			isFormValid: function () {
				return this.emailAddressValid
					&& this.companyCodeValid
			},
			onSubmit() {
				this.forgotPassword()
			},
			forgotPassword: function () {
				if (!this.isFormValid())
					return

				var credentials = {
					emailAddress: this.emailAddress,
					companyCode: this.companyCode
				}

				this.$store.dispatch("Profile/forgotPassword", credentials)
			},
			showPage: function (page) {
				this.$store.dispatch("Pages/show", page)
			}
		}
	}
</script>

<style scoped>
	.mh-login-logo img {
		width: 100%;
	}
</style>